angular.module('eStories.compnt.grid', [

    /*Grid Component*/

])

    .component('carouselGridItem', {
        transclude: true,
        bindings: {
            item: '<'
        },
        controller: 'GridCtrl',
        controllerAs: 'gridCtrl',
        templateUrl: '/components/templates/grid/carouselGridItem.tmpl.html'
    })

    .component('mobileCarouselGridItem', {
        transclude: true,
        bindings: {
            item: '<'
        },
        controller: 'GridCtrl',
        controllerAs: 'gridCtrl',
        templateUrl: '/components/templates/grid/mobileCarouselGridItem.tmpl.html'
    })

    .component('gridSixItem', {
        transclude: true,
        bindings: {
            item: '<'
        },
        controller: 'GridCtrl',
        controllerAs: 'gridCtrl',
        templateUrl: '/components/templates/grid/grid6Item.tmpl.html'
    })

    .component('gridItem', {
        transclude: true,
        bindings: {
            item: '=',
            libraryAudiobook: '<'
        },
        controller: 'GridCtrl',
        controllerAs: 'gridCtrl',
        templateUrl: '/components/templates/grid/gridItem.tmpl.html'
    })

    .component('listViewItem', {
        transclude: true,
        bindings: {
            item: '='
        },
        controller: 'GridCtrl',
        controllerAs: 'gridCtrl',
        templateUrl: '/components/templates/grid/listViewItem.tmpl.html'
    })

    .component('wishlistItem', {
        transclude: true,
        bindings: {
            item: '<'
        },
        controller: 'GridCtrl',
        controllerAs: 'gridCtrl',
        templateUrl: '/components/templates/wishList/wishlistItem.tmpl.html'
    })

    .controller('GridCtrl', [
        '$rootScope',
        'AccountModel',
        'PromoModel',
        'CatalogModel',
        '$state',
        'PlayerModel',
        '$location',
        'CtaModel',
        function ($rootScope,
                  AccountModel,
                  PromoModel,
                  CatalogModel,
                  $state,
                  PlayerModel,
                  $location,
                  CtaModel
        ) {

            var gridCtrl = this;

            gridCtrl.listView = false;

            gridCtrl.wishlistMode = $state.current.name === 'eStories.navbars.wishList';

            gridCtrl.account = AccountModel;

            gridCtrl.promo = PromoModel;

            gridCtrl.cta = CtaModel;

            gridCtrl.seeAllMode = $state.current.name === 'eStories.navbars.seeAll';

            gridCtrl.isThemedList = function () {
                return CatalogModel.isPageName('kid_control') ||
                    CatalogModel.isPageName('summer_listens') ||
                    CatalogModel.isPageName('off_the_beaten_path') ||
                    CatalogModel.isPageNameLike('on_sale') ||
                    CatalogModel.isPageName('trippin') ||
                    CatalogModel.isPageName('me_time') ||
                    CatalogModel.isPageName('sizzlin_hot') ||
                    CatalogModel.isPageName('oprah_says_so') ||
                    CatalogModel.isPageName('back_to_school') ||
                    CatalogModel.isPageName('short_and_sweet');
            };

            gridCtrl.showPurchaseOptions =
                CatalogModel.isPageName('great_first_listens') ||
                CatalogModel.isPageName('great_movie_tie_ins') ||
                CatalogModel.isPageName('pride_month') ||
                CatalogModel.isPageName('haunting_listens') ||
                CatalogModel.isPageName('holiday_season_2018') ||
                CatalogModel.isPageName('books_of_the_year_2018') ||
                CatalogModel.isPageName('chilling_listens') ||
                CatalogModel.isPageName('beyond_bracket_2019') ||
                CatalogModel.isPageName('national_book_award_longlist_2018') ||
                CatalogModel.isPageName('valentines_day') ||
                CatalogModel.isPageName('audie_winners') ||
                CatalogModel.isPageName('ursula_k_le_guin') ||
                CatalogModel.isPageNameLike('best_audiobooks_of') ||
                CatalogModel.isPageName('great_summer_listens');

            gridCtrl.audiobookAbridged = function (abridged) {
                return abridged ? 'Abridged' : 'Unabridged';
            };

            gridCtrl.getAudiobookRuntime = function (runtime) {
                if (runtime == null) {
                    return;
                }
                return runtime.toString().toHHMMSS();
            };

            gridCtrl.getFullDate = function (streetDate) {
                return getFullDate(streetDate);
            };

            gridCtrl.getStringDate = function (dateData) {
                return getStringDate(dateData);
            };

            gridCtrl.addToWishList = async function (audiobook, inWishlistPage, inSeeAllPage) {
                const response = await CatalogModel.addToWishList(audiobook);
                if (response != null && response.responseStatus === 'SUCCESS') {
                    if (inWishlistPage) {
                        gridCtrl.item.id = response.wishListItemId;
                    } else if (inSeeAllPage) {
                        gridCtrl.item.audiobook.wishListItemId = response.wishListItemId;
                    } else {
                        gridCtrl.item.wishListItemId = response.wishListItemId;
                    }
                }
            };

            gridCtrl.getProgressBarPercent = function (libraryAudiobook) {
                return PlayerModel.getAudiobookProgressBarPercent(libraryAudiobook);
            };

            gridCtrl.deleteFromWishList = async function (audiobook, inWishlistPage, inSeeAllPage) {
                //Check if on WishList Page
                const response = await CatalogModel.deleteFromWishList(audiobook);
                if (response != null && response.responseStatus === 'SUCCESS') {
                    if (inWishlistPage) {
                        $rootScope.$broadcast('updateWishlist', audiobook.wishListItemId);
                    } else if (inSeeAllPage) {
                        gridCtrl.item.audiobook.wishListItemId = null;
                    } else {
                        gridCtrl.item.wishListItemId = null;
                    }
                }
            };

            gridCtrl.playSample = function (audiobook) {
                $rootScope.$broadcast('playSample', audiobook);
            };

            gridCtrl.isAudiobookFree = function (audiobook) {
                if (audiobook) {
                    var pricesObj = audiobook.productList;
                    for (var i = 0; i < pricesObj.length; i++) {
                        if (pricesObj[i].purchaseType === 'RETAIL') {
                            if (pricesObj[i].nonMemberPrice === 0) {
                                return true;
                            } else {
                                return false;
                            }
                        }
                    }
                }
            }

            gridCtrl.doesAudiobookHaveProducts = function (audiobook) {
                if (audiobook) {
                    return audiobook.productList.length;
                }
            }

        }
    ]);


